import { Inbox, Flame, Clock as ClockIcon, CheckCircle2, MapPin } from "lucide-react";

export default function DashboardStats({ stats }) {
  const cards = [
    { label: "Total leads", value: stats?.total ?? "—", icon: Inbox, accent: "#11322A" },
    { label: "Hot leads", value: stats?.by_temperature?.hot ?? "—", icon: Flame, accent: "#B91C1C" },
    { label: "New", value: stats?.by_status?.new ?? "—", icon: ClockIcon, accent: "#E85D04" },
    { label: "Qualified", value: stats?.by_status?.qualified ?? "—", icon: CheckCircle2, accent: "#2D6A4F" },
    { label: "NY / NJ", value: stats ? `${stats.by_state.NY} / ${stats.by_state.NJ}` : "—", icon: MapPin, accent: "#11322A" },
  ];
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
      {cards.map((s) => (
        <div key={s.label} className="card-soft p-6" data-testid={`stat-${s.label}`}>
          <div className="flex items-center justify-between">
            <span className="label-cap">{s.label}</span>
            <s.icon className="h-4 w-4" style={{ color: s.accent }} />
          </div>
          <div className="mt-3 font-display text-3xl font-black tracking-tight text-[#0B1317]">{s.value}</div>
        </div>
      ))}
    </div>
  );
}
